import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["track", "slide", "indicator"]
  static values = {
    autoPlay: { type: Boolean, default: true },
    interval: { type: Number, default: 5000 }
  }

  connect() {
    this.currentIndex = 0
    this.updateSlider()
    this.startAutoPlay()
  }

  disconnect() {
    this.stopAutoPlay()
  }

  next() {
    this.stopAutoPlay()
    this.currentIndex = (this.currentIndex + 1) % this.slideTargets.length
    this.updateSlider()
    this.startAutoPlay()
  }

  previous() {
    this.stopAutoPlay()
    this.currentIndex = (this.currentIndex - 1 + this.slideTargets.length) % this.slideTargets.length
    this.updateSlider()
    this.startAutoPlay()
  }

  goToSlide(event) {
    this.stopAutoPlay()
    this.currentIndex = parseInt(event.currentTarget.dataset.index)
    this.updateSlider()
    this.startAutoPlay()
  }

  updateSlider() {
    const slidesPerView = this.getSlidesPerView()
    const maxIndex = Math.max(0, this.slideTargets.length - slidesPerView)
    const safeIndex = Math.min(this.currentIndex, maxIndex)

    const offset = -(safeIndex * (100 / slidesPerView))
    this.trackTarget.style.transform = `translateX(${offset}%)`

    this.indicatorTargets.forEach((indicator, index) => {
      if (index === safeIndex) {
        indicator.classList.remove("bg-gray-300")
        indicator.classList.add("bg-blue-600", "w-8")
      } else {
        indicator.classList.remove("bg-blue-600", "w-8")
        indicator.classList.add("bg-gray-300")
      }
    })
  }

  getSlidesPerView() {
    const width = window.innerWidth
    if (width >= 1024) return 3
    if (width >= 768) return 2
    return 1
  }

  startAutoPlay() {
    if (!this.autoPlayValue) return

    this.stopAutoPlay()
    this.autoPlayTimer = setInterval(() => {
      this.next()
    }, this.intervalValue)
  }

  stopAutoPlay() {
    if (this.autoPlayTimer) {
      clearInterval(this.autoPlayTimer)
      this.autoPlayTimer = null
    }
  }
}
